const IconPlus = props => (
	<svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 24 24" fill="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 3C12.592 3 13 3.5 13 4V11H20C20.5 11 21 11.5 21 12C21 12.5 20.5 13 20 13H13C13 13 13 19.5 13 20C13 20.5 12.5 21 12 21C11.5 21 11 20.5 11 20V13H4C3.5 13 3 12.5 3 12C3 11.5 3.5 11 4 11H11V4C11 3.5 11.5 3 12 3Z"
			fill="black"
		/>
	</svg>
);

export default IconPlus;
